import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';


/**
 * ScrollToTop
 *
 * This component listens to the current pathname and scrolls the
 * window to the top whenever the path changes.
 *
 * @return {null} This component does not render anything.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
